/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Monet.Builder = Monet.Builder || {};
Monet.Builder.Form = Monet.Builder.Form || {};

Monet.Builder.Form.Vertical = (function (){

    /**
     * FormBuilder constructor
     * @param {object} pageLayout
     * @constructor
     */
   function FormBuilderVertical (pageLayout, entity) {

        Monet.Builder.Form.Base.apply (this, arguments);

        this.render = function () {

            var baseForm = this.renderBaseForm ();
            var allContent = baseForm.allContent;
            allContent.className += ' Vertical';

            this.fragment.appendChild(allContent);

            return this.fragment;
        };

   }

   return FormBuilderVertical;

}());